import React from "react";
import { useMediaQuery } from "react-responsive";

import Switcher from "./switcher.jsx";
import BeforeSlider from "./before-slider.jsx";
import ScrollSlider from "./scroll-slider.jsx";
import DragImage from "./drag-image.jsx";

import GrabIcon from "../../../assets/svg/GrabIcon.svg";
import { request } from "../../../api";

const VtrgWasBecameImage = ({ data, slot }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  const firstImage = {
    imageUrl: `${request}${data.was_image.url}`,
    alt: data.became_image_alt || "Изображение до",
  };

  const secondImage = {
    imageUrl: `${request}${data.became_image.url}`,
    alt: data.was_image_alt || "Изображение после",
  };

  const dlmtrStyle = {
    width: isMobile ? "40px" : "50px",
    height: isMobile ? "40px" : "50px",
    border: `${isMobile ? "2px" : "3px"} solid #d9d9d9`,
    backgroundColor: "#fff",
    backgroundSize: "cover",
    backgroundImage: `url(${GrabIcon})`,
  };

  const items = {
    0: <Switcher was={firstImage} became={secondImage} />,
    1: (
      <BeforeSlider was={firstImage} became={secondImage} styles={dlmtrStyle} />
    ),
    2: <ScrollSlider was={firstImage} became={secondImage} />,
    3: <DragImage image={firstImage} />
  };

  const typeId = data?.was_became_type;

  return <div data-slot={slot}>{items[typeId]}</div>;
};

export default VtrgWasBecameImage;
